'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "HTTPError", {
  enumerable: true,
  get: function get() {
    return _HTTPError.default;
  }
});
Object.defineProperty(exports, "MissingConfigurationError", {
  enumerable: true,
  get: function get() {
    return _MissingConfigurationError.default;
  }
});
Object.defineProperty(exports, "ObjectAlreadyExists", {
  enumerable: true,
  get: function get() {
    return _ObjectAlreadyExists.default;
  }
});
Object.defineProperty(exports, "ObjectNotFound", {
  enumerable: true,
  get: function get() {
    return _ObjectNotFound.default;
  }
});
Object.defineProperty(exports, "ObjectUnprocessable", {
  enumerable: true,
  get: function get() {
    return _ObjectUnprocessable.default;
  }
});
Object.defineProperty(exports, "RequestMalformed", {
  enumerable: true,
  get: function get() {
    return _RequestMalformed.default;
  }
});
Object.defineProperty(exports, "RequestUnauthorized", {
  enumerable: true,
  get: function get() {
    return _RequestUnauthorized.default;
  }
});
Object.defineProperty(exports, "ServerError", {
  enumerable: true,
  get: function get() {
    return _ServerError.default;
  }
});
Object.defineProperty(exports, "ImportError", {
  enumerable: true,
  get: function get() {
    return _ImportError.default;
  }
});
Object.defineProperty(exports, "TypesenseError", {
  enumerable: true,
  get: function get() {
    return _TypesenseError.default;
  }
});

var _HTTPError = _interopRequireDefault(require("./HTTPError"));

var _MissingConfigurationError = _interopRequireDefault(require("./MissingConfigurationError"));

var _ObjectAlreadyExists = _interopRequireDefault(require("./ObjectAlreadyExists"));

var _ObjectNotFound = _interopRequireDefault(require("./ObjectNotFound"));

var _ObjectUnprocessable = _interopRequireDefault(require("./ObjectUnprocessable"));

var _RequestMalformed = _interopRequireDefault(require("./RequestMalformed"));

var _RequestUnauthorized = _interopRequireDefault(require("./RequestUnauthorized"));

var _ServerError = _interopRequireDefault(require("./ServerError"));

var _ImportError = _interopRequireDefault(require("./ImportError"));

var _TypesenseError = _interopRequireDefault(require("./TypesenseError"));
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/typesense-instantsearch-adapter/~/typesense/lib/Typesense/Errors/index.js
// module id = 1500
// module chunks = 0